/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Modal, Segment, Form, Input,
  Button, Divider, Dimmer, Loader, Icon,
  Header, Checkbox, Dropdown, Popup
} from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import UpdateLoader from "./UpdateLoader";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";
import sha256 from "js-sha256";
import Timezones from "../utilities/Timezones";

const UtilsInstance = new Utils();

class Configuration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      ntpAddr: "",
      isNtpActive: false,
      ntpCheckboxLabel: Strings.WLAN_ADAPTER_OFF,
      timezone: "",

      openFile: false,
      isNtpDimmerActive: false,
      isDimmerActive: false,
      isGSDDimmerActive: false,
      isResetLogDimmerActive: false,
      isResetOpticFiberLogDimmerActive: false,
      isRestartSystemModalOpen: false,
      isUpdateDimmerActive: false,
      isResetStatisticsDimmerActive: false,
      updateStatus: Constants.NOT_UPDATING,
      ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED,
      numOfSuccessfullFilesSent: 0,
      isNtpModalOpen: false,
      isTagConfigDimmerActive: false,
    };
    this.updateLoaderRef = React.createRef();
  }

  showDimmer = () => this.setState({ isDimmerActive: true });
  hideDimmer = () => this.setState({ isDimmerActive: false });

  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  showResetOpticFiberLogDimmer = () => this.setState({ isResetOpticFiberLogDimmerActive: true });
  hideResetOpticFiberLogDimmer = () => this.setState({ isResetOpticFiberLogDimmerActive: false });

  showGSDDimmer = () => this.setState({ isGSDDimmerActive: true });
  hideGSDDimmer = () => this.setState({ isGSDDimmerActive: false });

  showRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: true });
  hideRestartSystemModal = () => this.setState({ isRestartSystemModalOpen: false });

  showUpdateDimmer = () => this.setState({ isUpdateDimmerActive: true });
  hideUpdateDimmer = () => this.setState({ isUpdateDimmerActive: false });

  showResetStatisticsDimmer = () => this.setState({ isResetStatisticsDimmerActive: true });
  hideResetStatisticsDimmer = () => this.setState({ isResetStatisticsDimmerActive: false });

  showNtpDimmer = () => this.setState({ isNtpDimmerActive: true });
  hideNtpDimmer = () => this.setState({ isNtpDimmerActive: false });

  showNtpModal = () => this.setState({ isNtpModalOpen: true });
  hideNtpModal = () => this.setState({ isNtpModalOpen: false });

  showTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: true });
  hideTagConfigDimmer = () => this.setState({ isTagConfigDimmerActive: false });

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tag", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.tag)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "ntp", { mode: "cors" })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      tag: resolvedPromisses[0],
      ntpAddr: resolvedPromisses[1].ntpIp,
      isNtpActive: resolvedPromisses[1].ntp,
      timezone: resolvedPromisses[1].timezone,
      ntpCheckboxLabel: resolvedPromisses[1].ntp ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF
    });
  }

  //Sends a .gpg file to the server to update the monitor software
  sendFile = () => {
    let input = document.getElementById("send-gpg-input");
    // If the file exists and doesn't contain ".gpg" in its name
    if (input.files[0] !== undefined && input.files[0] !== null) {
      if (input.files[0].name.indexOf(Constants.GPG_FILE_EXTENSION) === -1) {
        alert(Strings.GPG_ALERT_MESSAGE);
      }
      else {
        let data = new FormData();
        let reader = new FileReader();
        let sha256Checksum = "";

        reader.onload = (event) => {
          sha256Checksum = sha256(event.target.result);

          data.append("updateFile", input.files[0]);
          data.append("checkSum", sha256Checksum);

          this.showDimmer();

          fetch(Constants.REQUEST_IP_ADDRESS + "sendFile_POST", {
            method: "POST",
            body: data
          })
            .then(UtilsInstance.checkStatus)
            .then(() => {
              this.handleUpdateCycles(Constants.FILE_UPDATE_TYPE);
            })
            .catch((error) => {
              if (error.response.status === 415) {
                alert(Strings.SEND_FILE_FAILURE + Strings.REASON + Strings.SEND_FILE_WRONG_FILENAME);
              }
              else if (error.response.status === 417) {
                alert(Strings.SEND_FILE_FAILURE + Strings.REASON + Strings.SEND_FILE_CORRUPTED_FILE);
              }
              else {
                alert(Strings.SEND_FILE_FAILURE + Strings.REASON + error);
              }

            })
            .finally(this.hideDimmer);
        };

        reader.onerror = (event) => {
          reader.abort();
          alert(Strings.SEND_FILE_FAILURE + Strings.REASON + event);
        };

        reader.readAsArrayBuffer(input.files[0]);
      }
    }
    else {
      alert(Strings.SELECT_FILE);
    }
  }

  sendGSDFiles = async () => {
    let input = document.getElementById("send-gsd-files-input");
    let notSentFilenames = [];

    if (input.files.length > 0) {

      document.getElementById("total-num-of-files").innerText = input.files.length;

      this.showGSDDimmer();

      for (let i = 0; i < input.files.length; i++) {
        let data = new FormData();
        data.append(input.files[i].name, input.files[i]);

        await fetch(Constants.REQUEST_IP_ADDRESS + "sendGsd_POST", {
          method: "POST",
          body: data
        })
          .then(UtilsInstance.checkStatus)
          .then(() => {
            // If the file was sent successfully, increment the number of files sent and show it on the loading dimmer
            this.setState({ numOfSuccessfullFilesSent: this.state.numOfSuccessfullFilesSent + 1 }, () => {
              document.getElementById("num-of-successful-files-sent").innerText = this.state.numOfSuccessfullFilesSent;
            });
          })
          .catch(() => {
            // If there was a problem while sending the file, add the file name to an array
            // so it can be shown to the user later
            notSentFilenames.push(input.files[i].name);
          });
      }

      // If all the files have been sent, alert the user
      if (notSentFilenames.length === 0) {
        setTimeout(() => {
          alert(Strings.SEND_FILES_SUCCESS);
          this.hideGSDDimmer();
          this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
            document.getElementById("num-of-successful-files-sent").innerText = 0;
          });
        }, 500);
      }
      // If at least one file was not sent, alert the user, and show a list of all of the files
      // that were not sent
      else {
        let notSentFilenamesList = "";

        for (let i = 0; i < notSentFilenames.length; i++) {
          notSentFilenamesList = notSentFilenamesList.concat("\n• " + notSentFilenames[i]);
        }

        alert(Strings.THE_FOLLOWING_FILES_COULD_NOT_BE_SENT + notSentFilenamesList);
        this.hideGSDDimmer();
        this.setState({ numOfSuccessfullFilesSent: 0 }, () => {
          document.getElementById("num-of-successful-files-sent").innerText = 0;
        });
      }
    }
    else {
      alert(Strings.SELECT_GSD_FLIE);
    }
  }

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetLog_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  cleanOpticFiberLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetOpticFiberLogDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "fiber/resetLog_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetOpticFiberLogDimmer);
  }

  cleanStatistics = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetStatisticsDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "resetStatistics_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_STATISTICS_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_STATISTICS_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetStatisticsDimmer);
  }

  handleTagChange = (e, { value }) => {
    this.setState({ tag: value });
  }

  getOpticFiberSegment = () => {
    if (sessionStorage.getItem("isFiberProcessOn") === "true") {
      return (
        <Segment style={updateSegmentStyle}>
          <Divider horizontal>
            {Strings.OPTIC_FIBER}
            {/* <Popup position='top center' hoverable pinned wide
              trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
              <Popup.Content>
                <p>Teste</p>
              </Popup.Content>
            </Popup> */}
          </Divider>
          <Button color="teal" onClick={this.opticFiber}>{Strings.SETUP}</Button>
        </Segment>

      );
    }
  }

  getCleanOpticFiberLogSegment = (isResetOpticFiberLogDimmerActive) => {
    if (sessionStorage.getItem("isFiberProcessOn") === "true") {
      return (
        <Segment style={updateSegmentStyle}>
          <Divider horizontal>{Strings.LOG} - {Strings.OPTIC_FIBER}</Divider>
          <Button color="teal" onClick={this.cleanOpticFiberLog}>{Strings.CLEAR}</Button>
          <Dimmer active={isResetOpticFiberLogDimmerActive} >
            <Loader>{Strings.WAITING}</Loader>
          </Dimmer>
        </Segment>
      );
    }
  }

  opticFiber = () => {
    this.props.history.push({ pathname: "/optic-fiber-config" });
  }

  handleNTPAddressChange = (e, { value }) => {
    this.setState({ ntpAddr: value });
  }

  toggleNtpActive = () => {
    this.setState({
      ntpCheckboxLabel: !this.state.isNtpActive ? Strings.WLAN_ADAPTER_ON : Strings.WLAN_ADAPTER_OFF,
      isNtpActive: !this.state.isNtpActive
    });
  }

  logOut = () => {
    sessionStorage.removeItem("auth");
    this.props.history.push({ pathname: "/login-handler" });
  }

  generateReport = () => {
    this.props.history.push({
      pathname: "/report"
    });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  changeLoginInfo = () => {
    this.props.history.push({ pathname: "/change-login" });
  }

  alterTags = () => {
    this.props.history.push({
      pathname: "/tags"
    });
  }

  removeGSD = () => {
    this.props.history.push({
      pathname: "/edit-gsd"
    });
  }

  editBlacklist = () => {
    this.props.history.push({
      pathname: "/blacklist"
    });
  }

  getModals = () => {
    return (
      <React.Fragment>
        <Modal basic size='small' open={this.state.isNtpModalOpen}>
          <Header icon='power' content={Strings.TURN_NTP_SERVER_ON} />
          <Modal.Content>
            <p>{Strings.TURN_NTP_SERVER_ON_QUESTION}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color='red'
              onClick={this.hideNtpModal}>
              <Icon name='remove' />
              {Strings.NO}
            </Button>
            <Button
              color='green'
              onClick={this.handleTurnNtpServerOnModalPositiveClick}>
              <Icon name='checkmark' />
              {Strings.YES}
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal basic size='small' open={this.state.isRestartSystemModalOpen}>
          <Header icon='history' content={Strings.RESTART_SYSTEM} />
          <Modal.Content>
            <p>{Strings.CONFIRM_RESTART_SYSTEM}</p>
          </Modal.Content>
          <Modal.Actions>
            <Button color='red' onClick={this.hideRestartSystemModal}><Icon name='remove' />{Strings.NO}</Button>
            <Button color='green' onClick={this.handleRestartSystemModalPositiveClick}><Icon name='checkmark' />{Strings.YES}</Button>
          </Modal.Actions>
        </Modal>
      </React.Fragment>
    );
  }

  handleRestartSystemModalPositiveClick = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "restartSystem_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data,
      mode: "cors"
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.RESTART_SYSTEM_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.RESTART_SYSTEM_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideRestartSystemModal);
  }

  handleUpdateCycles = (updateType) => {
    this.showUpdateDimmer();
    let intervalID = -1;

    if (updateType === Constants.FILE_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
      intervalID = setInterval(this.handleUpdateStatus, 2000);
    }
    else if (updateType === Constants.NTP_UPDATE_TYPE) {
      this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
      intervalID = setInterval(this.handleUpdateNtpStatus, 2000);
    }
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.UPDATE_FILES_FOUND) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.UPDATING_MONITOR_FILES);
          });
        }
        else if (this.state.updateStatus === Constants.UPDATE_FILES_FOUND && data.update === Constants.FINISHED_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.MONITOR_FILES_UPDATED_SUCCESSFULLY);
          });
        }
        else if (this.state.updateStatus === Constants.FINISHED_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.DO_NOT_CLOSE_THIS_TAB, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.UPDATE_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.UPDATE_ERROR_STRING + error);
      });
  }

  handleUpdateNtpStatus = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "updateStatus", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.updateStatus);
        console.log("Data update Status: ", data.update);

        if (this.state.updateStatus === Constants.NOT_UPDATING && data.update === Constants.RESTARTING_MONITOR) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, Strings.RESTARTING_MONITOR_WAIT);
          });
        }
        else if (this.state.updateStatus === Constants.RESTARTING_MONITOR && data.update === Constants.NOT_UPDATING) {
          this.setState({ updateStatus: data.update }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.SEND_NTP_CONFIG_DONE, "");
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.MONITOR_RESTART_SUCCESS);
            this.retrieveData();
          });
        }
      })
      .catch((error) => {
        console.log(Strings.MONITOR_RESTART_FAILURE + error);
      });

  }

  handleTurnNtpServerOnModalPositiveClick = () => {
    this.hideNtpModal();
    this.updateNtpServer();
  }

  saveNtpServerInfo = () => {
    let isIpValid = UtilsInstance.validateIPAddress(this.state.ntpAddr);
    let isIPLoopback = UtilsInstance.isIPLoopback(this.state.ntpAddr);

    // Verify the network information provided. Only send it if it passes the validation
    if (!isIpValid || isIPLoopback || this.state.timezone.length === 0) {
      let invalidInformationString = Strings.VERIFY_THE_FOLLOWING_INFO;

      // If the IP is not valid or if it is the loopback IP (127.0.0.1)
      if (!isIpValid) {
        invalidInformationString = invalidInformationString.concat(Strings.INVALID_IP);
      }
      else if (isIPLoopback) {
        invalidInformationString = invalidInformationString.concat(Strings.LOOPBACK_IP_NTP);
      }

      if (this.state.timezone.length === 0) {
        invalidInformationString = invalidInformationString.concat(Strings.SELECT_TIMEZONE);
      }

      alert(invalidInformationString);
    }
    else {
      // If the user is turning the ntp server off there is no need to ask
      // for permission to restart because the system will not restart
      if (this.state.isNtpActive === false) {
        this.updateNtpServer();
      }
      // If the user is turning the ntp server on we will need ask for permission
      // to restart the system
      else {
        this.showNtpModal();
      }
    }
  }

  updateNtpServer = () => {
    let data = JSON.stringify({
      ntp: this.state.isNtpActive,
      ntpIp: this.state.ntpAddr,
      timezone: this.state.timezone
    });

    if (this.state.isNtpActive === false) {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_OFF_FAILURE + Strings.REASON + Strings.NTP_INFO_FAILURE);
          this.toggleNtpActive();
        })
        .finally(this.hideNtpDimmer);
    }
    else {
      this.showNtpDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "ntp_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: data
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          this.updateNtpServerFirstStep();
        })
        .catch((error) => {
          this.toggleNtpActive();
          console.log(error);
          alert(Strings.NTP_INFO_TURNED_ON_FAILURE + Strings.REASON + Strings.NTP_INFO_FAILURE);
        })
        .finally(this.hideNtpDimmer);
    }
  }

  updateNtpServerFirstStep = () => {
    let intervalID = -1;
    this.showUpdateDimmer();
    this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INIT, "");
    intervalID = setInterval(this.handleUpdateNtpFirstStep, 2000);
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: intervalID });
  }

  handleUpdateNtpFirstStep = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "ntpUpdate", { mode: "cors" })
      .then(res => res.json())
      .then((data) => {

        console.log("Status atual da tela: ", this.state.ntpUpdate);
        console.log("Data update Status: ", data.ntpUpdate);

        if (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED && data.ntpUpdate === Constants.NTP_UPDATE_START) {
          this.setState({ ntpUpdate: data.ntpUpdate }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSING_NTP_INFO, "");
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_SUCCESS
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.updateLoaderRef.current.changeLoaderText(Strings.PROCESSED_NTP_INFO, "");
            clearInterval(this.state.intervalID);
            this.handleUpdateCycles(Constants.NTP_UPDATE_TYPE);
          });
        }
        else if (
          (this.state.ntpUpdate === Constants.NTP_UPDATE_NOT_STARTED || this.state.ntpUpdate === Constants.NTP_UPDATE_START)
          && data.ntpUpdate === Constants.NTP_UPDATE_FAIL
        ) {
          this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED }, () => {
            this.hideUpdateDimmer();
            clearInterval(this.state.intervalID);
            alert(Strings.PROCESSING_NTP_ERROR);
            this.toggleNtpActive();
          });
        }
      })
      .catch(() => {
        this.hideUpdateDimmer();
        clearInterval(this.state.intervalID);
        this.setState({ ntpUpdate: Constants.NTP_UPDATE_NOT_STARTED });
        alert(Strings.PROCESSING_NTP_ERROR);
        this.toggleNtpActive();
      });
  }

  onTimezoneDropdownChange = (e, { value }) => this.setState({ timezone: value })

  configureTsExpert = () => {
    this.props.history.push({ pathname: "/ts-expert-config" });
  }

  openEthernetPage = () => {
    this.props.history.push({ pathname: "/ethernet-config" });
  }

  openWLANPage = () => {
    this.props.history.push({ pathname: "/wlan-config" });
  }

  sendTag = () => {
    this.showTagConfigDimmer();

    fetch(Constants.REQUEST_IP_ADDRESS + "tag_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({ tag: this.state.tag })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TAG_WAS_CHANGED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TAG_CHANGE_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideTagConfigDimmer);
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    const isDimmerActive = this.state.isDimmerActive;
    const isNtpDimmerActive = this.state.isNtpDimmerActive;
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;
    const isResetOpticFiberLogDimmerActive = this.state.isResetOpticFiberLogDimmerActive;
    const isGSDDimmerActive = this.state.isGSDDimmerActive;
    const isUpdateDimmerActive = this.state.isUpdateDimmerActive;
    const isResetStatisticsDimmerActive = this.state.isResetStatisticsDimmerActive;
    const isTagConfigDimmerActive = this.state.isTagConfigDimmerActive;

    return (
      <div>
        <p id="demo"></p>
        <div style={logoutButtonContainer}>
          <Button
            icon
            style={logoutButtonStyle}
            color="red"
            onClick={this.showRestartSystemModal}>
            <Icon name='power off' />
            {Strings.RESTART_SYSTEM}
          </Button>
          <Button style={logoutButtonStyle} color="grey" onClick={this.logOut}>{Strings.LOGOUT}</Button>
        </div>

        <Grid columns={2} doubling>
          <Grid.Column>
            <Segment>
              <Divider horizontal>{Strings.TAG_CONFIG}</Divider>
              <Form style={formStyle} onSubmit={this.sendTag}>

                <Form.Field inline>
                  <label style={labelStyle}>{Strings.TAG}</label>
                  <Input style={inputStyle}
                    placeholder={Strings.TEST_NETWORK}
                    value={this.state.tag}
                    onChange={this.handleTagChange} />
                </Form.Field>

                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>
              <Dimmer active={isTagConfigDimmerActive} >
                <Loader>{Strings.SEND_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment textAlign="center">
              <Divider horizontal>{Strings.NTP_SERVER}</Divider>

              <Form onSubmit={this.saveNtpServerInfo}>

                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", paddingBottom: "1vh" }}>
                  <div style={{ flexGrow: 2 }}>
                    <Form.Field>
                      <label>{Strings.IP}</label>
                      <Input
                        fluid
                        placeholder="192.168.0.2"
                        value={this.state.ntpAddr}
                        onChange={this.handleNTPAddressChange} />
                    </Form.Field>

                    <Form.Field>
                      <label>{Strings.TIMEZONE}</label>
                      <Dropdown
                        fluid
                        placeholder={Strings.TIMEZONE}
                        search
                        selection
                        scrolling
                        options={Timezones.zones}
                        value={this.state.timezone}
                        onChange={this.onTimezoneDropdownChange} />
                    </Form.Field>
                  </div>
                  <div style={{ flexGrow: 1 }}>
                    <Form.Field>
                      <Checkbox
                        toggle
                        onClick={this.toggleNtpActive}
                        checked={this.state.isNtpActive}
                        label={this.state.ntpCheckboxLabel} />
                    </Form.Field>
                  </div>
                </div>

                <Button color="teal" type="submit">{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={isNtpDimmerActive} >
                <Loader>{Strings.SEND_NTP_CONFIG_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.BLACKLIST_STRING}</Divider>
                  <Button color="teal" onClick={this.editBlacklist}>{Strings.EDIT}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.TAGS}</Divider>
                  <Button color="teal" onClick={this.alterTags}>{Strings.EDIT}</Button>
                </Segment>
              </Grid.Column>
            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.ETHERNET}
                    <Popup position='top center' hoverable pinned wide
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.ETHERNET_POPUP_1}</p>
                        <p>{Strings.ETHERNET_POPUP_2}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openEthernetPage} />
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>
                    {Strings.WLAN}
                    <Popup position='top center' hoverable pinned wide="very"
                      trigger={<Icon name="question circle" size="big" color="teal" style={questionIconStyle} />}>
                      <Popup.Content>
                        <p>{Strings.WLAN_POPUP_1}</p>
                        <p>{Strings.WLAN_POPUP_2}</p>
                      </Popup.Content>
                    </Popup>
                  </Divider>
                  <Button
                    content={Strings.SETUP}
                    color="teal"
                    onClick={this.openWLANPage} />
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.TS_EXPERT}</Divider>
                  <Button color="teal" onClick={this.configureTsExpert}>{Strings.SETUP}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                {this.getOpticFiberSegment()}
              </Grid.Column>

            </Grid>
          </Grid.Column>

          <Grid.Column>

            <Segment style={updateSegmentStyle}>
              <Divider horizontal>{Strings.SOFTWARE_UPDATE}</Divider>
              <p>{Strings.CURRENT_VERSION}<strong>{Constants.TS_MONITOR_VERSION}</strong></p>
              <Form style={formStyle} onSubmit={this.sendFile}>
                <Form.Input id="send-gpg-input" type="file" accept=".gpg"></Form.Input>
                <Button color="teal" type="submit" >{Strings.UPDATE}</Button>
              </Form>
              <Dimmer active={isDimmerActive} >
                <Loader>{Strings.SEND_FILE_WAITING}</Loader>
              </Dimmer>
            </Segment>

            <Segment style={updateSegmentStyle}>
              <Divider horizontal>{Strings.GSD_FILES}</Divider>
              <Form style={formStyle}>
                <Form.Input id="send-gsd-files-input" type="file" accept=".gse,.gsf,.gsg,.gsi,.gsp,.gss,.gsd" multiple></Form.Input>
                <div style={gsdmlFormStyle}>
                  <div style={gsdmlLeftButtonStyle}>
                    <Button color="teal" onClick={this.sendGSDFiles}>{Strings.SEND}</Button>
                  </div>
                  <div style={gsdmlRightButtonStyle}>
                    <Button color="teal" onClick={this.removeGSD}>{Strings.MANAGE}</Button>
                  </div>
                </div>
              </Form>
              <Dimmer active={isGSDDimmerActive} >
                <Loader><p>{Strings.SENDING_GSD_FILES}</p>
                  <p><span id="num-of-successful-files-sent">0</span> / <span id="total-num-of-files"></span></p></Loader>
              </Dimmer>
            </Segment>

            <Grid columns={2} doubling>
              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.LOG}</Divider>
                  <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetLogDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.STATISTICS}</Divider>
                  <Button color="teal" onClick={this.cleanStatistics}>{Strings.CLEAR}</Button>
                  <Dimmer active={isResetStatisticsDimmerActive} >
                    <Loader>{Strings.WAITING}</Loader>
                  </Dimmer>
                </Segment>
              </Grid.Column>

            </Grid>

            <Grid columns={2} doubling>
              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.REPORT}</Divider>
                  <Button color="teal" onClick={this.generateReport}>{Strings.GENERATE_REPORT}</Button>
                </Segment>
              </Grid.Column>

              <Grid.Column>
                <Segment style={updateSegmentStyle}>
                  <Divider horizontal>{Strings.ALTER_LOGIN}</Divider>
                  <Button color="teal" onClick={this.changeLoginInfo}>{Strings.ALTER}</Button>
                </Segment>
              </Grid.Column>
            </Grid>

            <Grid columns={2} doubling>
              <Grid.Column>
                {this.getCleanOpticFiberLogSegment(isResetOpticFiberLogDimmerActive)}
              </Grid.Column>

              <Grid.Column>
              </Grid.Column>
            </Grid>

          </Grid.Column>
        </Grid >

        {this.getModals()}

        <Dimmer page active={isUpdateDimmerActive} >
          <UpdateLoader ref={this.updateLoaderRef} />
        </Dimmer >
      </div >
    );
  }
}

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const updateSegmentStyle = {
  textAlign: "center"
};

const labelStyle = {
  width: "20%"
};

const inputStyle = {
  width: "70%"
};

const logoutButtonContainer = {
  textAlign: "right"
};

const logoutButtonStyle = {
  marginBottom: "1em"
};

const gsdmlFormStyle = {
  display: "flex"
};

const gsdmlLeftButtonStyle = {
  flexGrow: "1",
  textAlign: "center"
};

const gsdmlRightButtonStyle = {
  flexGrow: "1",
  textAlign: "center"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default withRouter(Configuration);